// Ledger affiliate i18n — texts for CTAs across TopWallet & Shadow Network.
// Affiliate ID: eb740c0da9e0 · 10% commission · paid in BTC.
export const i18nLedger = {
  ctaTitulo: {
    es: "🔷 Protege tus criptomonedas hoy",
    en: "🔷 Protect your cryptocurrencies today",
    sk: "🔷 Chráň svoje kryptomeny dnes", de: "🔷 Schütze deine Kryptowährungen heute", "zh-CN": "🔷 立即保护您的加密货币",
  },
  ctaSubtitulo: {
    es: "La hardware wallet más vendida del mundo — tus claves privadas nunca tocan internet.",
    en: "The best-selling hardware wallet in the world — your private keys never touch the internet.",
    sk: "Najpredávanejšia hardvérová peňaženka na svete — tvoje súkromné kľúče sa nikdy nedotknú internetu.", de: "Die meistverkaufte Hardware-Wallet der Welt — deine privaten Schlüssel berühren niemals das Internet.", "zh-CN": "全球销量第一的硬件钱包——您的私钥永不触网。",
  },
  ctaBadge: {
    es: "RECOMENDADO POR RE₿EL",
    en: "RECOMMENDED BY RE₿EL",
    sk: "ODPORÚČANÉ RE₿EL", de: "EMPFOHLEN VON RE₿EL", "zh-CN": "RE₿EL 推荐",
  },
  aviso: {
    es: "Enlace de afiliado · Al comprar a través de este link apoyas a RE₿EL Academy sin ningún coste adicional para ti.",
    en: "Affiliate link · By purchasing through this link you support RE₿EL Academy at no extra cost to you.",
    sk: "Partnerský odkaz · Nákupom cez tento odkaz podporuješ RE₿EL Academy bez akýchkoľvek dodatočných nákladov.", de: "Affiliate-Link · Beim Kauf über diesen Link unterstützt du RE₿EL Academy ohne zusätzliche Kosten für dich.", "zh-CN": "推广链接 · 通过此链接购买，您无需支付额外费用即可支持 RE₿EL Academy。",
  },
  mejorPrecio: { es: "Mejor precio", en: "Best price", sk: "Najlepšia cena", de: "Bester Preis", "zh-CN": "最优价格" },
  masVendida: { es: "Más vendida", en: "Best seller", sk: "Najpredávanejšia", de: "Meistverkauft", "zh-CN": "最畅销" },
  premium: { es: "Premium", en: "Premium", sk: "Premium", de: "Premium", "zh-CN": "高级版" },
  comprarEn: { es: "Comprar en Ledger →", en: "Buy at Ledger →", sk: "Kúpiť na Ledger →", de: "Bei Ledger kaufen →", "zh-CN": "前往 Ledger 购买 →" },
  verTodos: { es: "Ver todos los modelos →", en: "See all models →", sk: "Zobraziť všetky modely →", de: "Alle Modelle ansehen →", "zh-CN": "查看所有型号 →" },
  desde: { es: "Desde", en: "From", sk: "Od", de: "Ab", "zh-CN": "起价" },
  comision: {
    es: "10% de comisión va a RE₿EL Academy",
    en: "10% commission goes to RE₿EL Academy",
    sk: "10% provízia ide na RE₿EL Academy", de: "10% Provision geht an RE₿EL Academy", "zh-CN": "10% 佣金将支持 RE₿EL Academy",
  },
  shadowEyebrow: {
    es: "🔒 SEGURIDAD RECOMENDADA",
    en: "🔒 RECOMMENDED SECURITY",
    sk: "🔒 ODPORÚČANÁ BEZPEČNOSŤ", de: "🔒 EMPFOHLENE SICHERHEIT", "zh-CN": "🔒 推荐安全措施",
  },
  shadowCopy: {
    es: "Los traders PRO guardan sus fondos en hardware wallet.",
    en: "PRO traders keep their funds on a hardware wallet.",
    sk: "PRO traderi držia prostriedky v hardvérovej peňaženke.", de: "PRO-Trader bewahren ihre Gelder in Hardware-Wallets auf.", "zh-CN": "专业交易者将资金存放在硬件钱包中。",
  },
  shadowCta: {
    es: "🔷 Ledger — Desde €79 →",
    en: "🔷 Ledger — From €79 →",
    sk: "🔷 Ledger — Od €79 →", de: "🔷 Ledger — Ab €79 →", "zh-CN": "🔷 Ledger — 起价 €79 →",
  },
  shadowAviso: {
    es: "* Enlace de afiliado · Apoya a RE₿EL",
    en: "* Affiliate link · Supports RE₿EL",
    sk: "* Partnerský odkaz · Podporuje RE₿EL", de: "* Affiliate-Link · Unterstütze RE₿EL", "zh-CN": "* 推广链接 · 支持 RE₿EL",
  },
};

export const pickLang = (obj, lang) => (obj && (obj[lang] || obj.es)) || "";
